<template>
    <el-dialog
            :title="!dataForm.id ? '新增' : '修改'"
            :close-on-click-modal="false"
            :visible.sync="visible">
        <el-form :model="dataForm" ref="dataForm" @keyup.enter.native="dataFormSubmit()"
                 label-width="160px">
            <el-form-item label="数据源名称" prop="title">
                <el-input v-model="dataForm.title" placeholder="数据源名称"></el-input>
            </el-form-item>
            <el-form-item label="JDBC URL" prop="url">
                <el-input type="textarea" v-model="dataForm.url" placeholder="JDBC URL" :rows="5"></el-input>
            </el-form-item>
            <el-form-item label="用户名" prop="username">
                <el-input v-model="dataForm.username" placeholder="用户名"></el-input>
            </el-form-item>
            <el-form-item label="密码" prop="password">
                <el-input v-model="dataForm.password" type="password" show-password placeholder="密码"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="dataFormSubmit()" style="float:right">测试连接</el-button>
            </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" @click="save()">确定</el-button>
    </span>
    </el-dialog>
</template>

<script>
    export default {
        props: ['mainContentViewHeight'],
        data() {
            return {
                visible: false,
                dataForm: {
                    id: '',
                    title: '',
                    url: '',
                    username: '',
                    password: ''
                }
            }
        },
        methods: {
            init(id) {
                this.dataForm.id = id || ''
                this.visible = true
                if (this.dataForm.id) {
                    this.$http({
                        url: this.$http.adornUrl('/customform/datasourceconfig/get?id=' + this.dataForm.id),
                        method: 'get',
                        baseURL: '',
                    }).then(({data}) => {
                        if (data && data.code === '1') {
                            this.dataForm = data.data
                        } else {
                            this.dataForm = {
                                id: '',
                                title: '',
                                url: '',
                                username: ''
                            }
                        }
                    })
                }
            },
            // 表单提交
            dataFormSubmit() {
                this.$http({
                    url: this.$http.adornUrl('/customform/datasourceconfig/checkConnectStatus?url=' + this.dataForm.url + '&username=' + this.dataForm.username + '&password=' + this.dataForm.password),
                    method: 'get',
                    baseURL: '',
                }).then(({data}) => {
                    if (data && data.code === '1') {
                        this.$message.success(data.msg)
                    } else {
                        this.$message.error(data.msg)
                    }
                })
            },
            save() {
                this.$http({
                    url: this.$http.adornUrl('/customform/datasourceconfig/save'),
                    method: 'post',
                    baseURL: '',
                    data: {
                        'id': this.dataForm.id,
                        'title': this.dataForm.title,
                        'url': this.dataForm.url,
                        'username': this.dataForm.username,
                        'password': this.dataForm.password,
                    }
                }).then(({data}) => {
                    if (data && data.code === '1') {
                        this.visible = false;
                        this.$parent.getDataList();
                    } else {
                        this.$message.error(data.msg)
                    }
                })
            }
        }
    }
</script>
